<template>
  <div :class="classnames">
    <h1 v-if="text" :class="`${ns}__text`">{{ text }}</h1>
    <div v-else :class="`${ns}__placeholder`" />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'toolbar-page-headline'

  export default {
    name: 'ToolbarPageHeadline',
    mixins: [ bem ],
    props: {
      text: {
        type: String
      }
    },
    data () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ToolbarPageHeadline.vue